import { Injectable } from '@angular/core';
import { Entity } from '@ex/survey-x/index';
import { TenantService } from './tenant.service';
import { EntityService } from './entity.service';
import { products } from '../data-models/company-permission';
import { HappinessService } from './happiness.service';
import { delay, map, switchMap } from 'rxjs/operators';
import { combineLatest, Observable, of } from 'rxjs';
import { TenantLabel } from '../data-models/tenant';
import { EngagementService } from './engagement.service';

export interface LandingParamsResponse {
  isWhiteLabel?: boolean,
  isSecureLanding?: boolean
  entity?: Entity,
  tenantKey?: string,
  companyKey?: string,
  surveyKey?: string

}
@Injectable({
  providedIn: null
})
export class SecureLandingService {

  constructor(private tenantService: TenantService, private entityService: EntityService, private happinessService: HappinessService, private engagementService: EngagementService) { }

  specialLandingParams(ref: string, module: string): Observable<LandingParamsResponse> {
    if (module === products.Wellbeing) {
      return of({
        companyKey: 'wellbeing-company',
        isSecureLanding: false
      }).pipe(delay(200));
    }

    if (module === products.AiReadiness) {
      return of({
        companyKey: 'ai-readiness-company',
        isSecureLanding: false
      }).pipe(delay(200));
    }

    if (module === products.Culture) {
      return of({
        companyKey: 'culture-company',
        isSecureLanding: false
      });
    }

    const [tenantKey, companyKey, surveyKey] = atob(ref).split('#@#');
    if (!tenantKey || !companyKey || !surveyKey)
      throw new Error("one of the keys is missing");


    const service = this.getServiceForProduct(module);
    if (!service) throw new Error('Unsupported product');


    const whiteLabelResolver$: Observable<LandingParamsResponse> = this.tenantService.fetchTenant(tenantKey).pipe(switchMap(tenant => {
      if (tenant?.clientLabel == TenantLabel.WhiteLabeled)
        return this.entityService.fetchEntity(tenantKey, companyKey).pipe(map(entity => {
          return { isWhiteLabel: true, entity }
        }));
      return of({})
    }));


    const secureLandingResolver$: Observable<LandingParamsResponse> = service.fetchEngagement(tenantKey, companyKey, surveyKey).pipe(map((engagement: any) => ({ isSecureLanding: !!engagement.isSecureLanding })));

    return combineLatest([whiteLabelResolver$, secureLandingResolver$]).pipe(map(([whiteLabel, secureLanding]) => ({ ...whiteLabel, ...secureLanding, tenantKey, companyKey, surveyKey })))
  }




  private getServiceForProduct = (product: string) => {
    if (product === products.Happiness) return this.happinessService;
    if (product === products.Engagement) return this.engagementService;
    return null;
  };


}
